/**
 * ProjectMilestoneTaskService
 * Service for ProjectMilestoneTask entity operations
 * Route: api/project-milestone-tasks
 * Controller: ProjectMilestoneTaskController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProjectMilestoneTaskService
 * Handles project milestone task CRUD operations
 * Maps to /api/project-milestone-tasks endpoint
 */
export class ProjectMilestoneTaskService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectMilestoneTaskService.DEFAULT_SERVICE_PATH,
            basePath: ProjectMilestoneTaskService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ProjectMilestoneTaskService.DEFAULT_SERVICE_PATH = 'projects';
ProjectMilestoneTaskService.BASE_PATH = 'api/project-milestone-tasks';
//# sourceMappingURL=ProjectMilestoneTaskService.js.map